import { memo, useState } from 'react';
import SelectableChip from '../../SelectableChip.jsx';
import FilterSlideoutSection from '../FilterSlideoutSection.jsx';
import {
  FILTER_SLIDEOUT_CHIP_LIST,
  FILTER_SLIDEOUT_DISCLOSURE,
} from '../filterSlideoutTokens.js';
import {
  clearSection,
  getSectionActiveCount,
  getVisibleItems,
  includesValue,
  toggleArrayValue,
} from '../filterSlideout.utils.js';
import { ChevronDown, ChevronUp } from 'lucide-react';

const ChipSelectSection = ({ section }) => {
  const activeCount = getSectionActiveCount(section);
  const [showAll, setShowAll] = useState(false);
  const options = section.options ?? [];
  const { visibleItems, hiddenCount, hasOverflow } = getVisibleItems(
    options,
    section.maxVisible ?? 6,
    showAll,
  );

  const handleToggle = (option) => {
    if (option.disabled || section.disabled) return;

    if (section.multiple === false) {
      section.onChange?.(section.value === option.value ? '' : option.value);
      return;
    }

    section.onChange?.(toggleArrayValue(section.value, option.value));
  };

  return (
    <FilterSlideoutSection
      title={section.title}
      defaultExpanded={section.defaultExpanded ?? true}
      disabled={section.disabled}
      activeCount={activeCount}
      onClear={() => clearSection(section)}
    >
      <div className={FILTER_SLIDEOUT_CHIP_LIST}>
        {visibleItems.map((option) => {
          const selected = includesValue(section.value, option.value);

          return (
            <SelectableChip
              key={option.value}
              selected={selected}
              disabled={section.disabled || option.disabled}
              size="s"
              className="max-w-[120px] overflow-hidden"
              onClick={() => handleToggle(option)}
            >
              <span className="truncate">{option.label}</span>
            </SelectableChip>
          );
        })}

        {hasOverflow || showAll ? (
          <button
            type="button"
            className={FILTER_SLIDEOUT_DISCLOSURE}
            onClick={() => setShowAll((value) => !value)}
          >
            {showAll ? 'Show less' : `+${hiddenCount} more`}
            {showAll ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          </button>
        ) : null}
      </div>
    </FilterSlideoutSection>
  );
};

export default memo(ChipSelectSection);
